/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { ReactNode } from "react";
import { HorizontalScroll } from "./HorizontalScroll";
import mq from "../../constants/mediaqueries";

type Tab = {
    title?: string | ReactNode;
    value: string;
    count?: number;
    subtitle?: string;
    isActive?: boolean;
    [key: string]: any;
}

interface TabsProps {
    tabs: Tab[];
    activeTab?: string | null;
    onSwitchTab?: (tab: Tab) => void;
    withCount?: boolean;
    variant?: "default" | "boxed";
}

export const Tabs = ({ tabs, activeTab, onSwitchTab, withCount, variant }: TabsProps) => {
    const activeButtonColor = variant === "boxed" ? "transparent" : "#fff";
    const inactiveButtonColor = variant === "boxed" ? "transparent" : "#e5e8e5";

    return (
        <div className="w-100">
            <HorizontalScroll withArrow fadeColor="#f4f9ff" className={variant === "boxed" ? "gap-0" : "gap-2"}>
                {tabs.map(({ title, subtitle, isActive, count, ...tab }, index) => {
                    const isTabActive = isActive || tab.value === activeTab;

                    return (
                        <button
                            key={index}
                            className="px-3 py-3 text-nowrap"
                            css={[
                                css`
                                    border: none;
                                    color: unset;
                                    text-align: center;
                                    background-color: ${isTabActive ? activeButtonColor : inactiveButtonColor};
                                    ${isTabActive ? "font-weight: 900;" : ""}
                                `,
                                variant === "boxed"
                                    ? css`
                                        position: relative;
                                        &:after {
                                            content: '';
                                            position: absolute;
                                            bottom: 0;
                                            left: 50%;
                                            width: ${isTabActive ? "100%" : "0"};
                                            height: 3px;
                                            z-index: 1;
                                            background-color: #444;
                                            transform: translateX(-50%);
                                            transition: width 0.3s ease;
                                        }
                                    `
                                    : mq({
                                        borderRadius: ["8px 8px 0px 0px"],
                                        borderBottom: [`2px solid ${isTabActive ? "#fff" : "#eee"}`],
                                    }),
                            ]}
                            onClick={onSwitchTab && (() => onSwitchTab(tab))}
                            {...tab}
                        >
                            <h6
                                className="mb-0 text-no-wrap fw-bold"
                                css={css`opacity: ${isTabActive ? 1 : 0.5};`}
                            >
                                {title} {withCount && <span className="opacity-60 ms-2">{count || "-"}</span>}
                            </h6>

                            {subtitle && <p className="text-muted py-10">{subtitle}</p>}
                        </button>
                    );
                })}
            </HorizontalScroll>
        </div>
    );
};
